export default __webpack_public_path__ + "static/media/500.53b1a42f.svg";